module.exports = __webpack_public_path__ + "img/textura-elvas-branco@3x.69f416ea.png";